export default "__VITE_ASSET__CQSswOZW__"